import useStore from 'base/store'
import {logout} from 'modules/auth'

const useNoReloadLogout = () => {
  const setRole = useStore((state) => state.setRole)
  const setSession = useStore((state) => state.setSession)

  return () => {
    logout(true)
    setRole(null)
    setSession(null)
  }
}

export default useNoReloadLogout
